/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lap records the time at that moment without stopping the stopwatch, so you can capture splits — useful for workouts, races and intervals.`)
};

const es_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vuelta registra el tiempo en ese momento sin detener el cronómetro, para que puedas capturar parciales — útil para entrenamientos, carreras e intervalos.`)
};

const de_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Runde erfasst die Zeit in diesem Moment, ohne die Stoppuhr zu stoppen, sodass du Zwischenzeiten festhalten kannst — nützlich für Workouts, Rennen und Intervalle.`)
};

const nl_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een ronde legt de tijd op dat moment vast zonder de stopwatch te stoppen, zodat je tussentijden kunt vastleggen — handig voor trainingen, wedstrijden en intervallen.`)
};

const fr_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tour enregistre le temps à cet instant précis sans arrêter le chronomètre, ce qui permet de capturer des temps intermédiaires — utile pour les entraînements, les courses et les intervalles.`)
};

const it_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un giro registra il tempo in quel momento senza fermare il cronometro, così puoi catturare i tempi parziali — utile per allenamenti, gare e intervalli.`)
};

const pt_br2_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma volta registra o tempo naquele momento sem parar o cronômetro, permitindo capturar parciais — útil para treinos, corridas e intervalos.`)
};

const pt_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma volta regista o tempo nesse instante sem parar o cronómetro, permitindo capturar parciais — útil para treinos, corridas e intervalos.`)
};

const ja_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラップは、ストップウォッチを止めずにその時点の時間を記録する機能です。区間タイムを記録できるため、ワークアウトやレース、インターバルトレーニングに便利です。`)
};

const zh_timer_stopwatch_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计圈会记录当下的时间，而不会停止秒表，方便你记录分段用时 — 适用于锻炼、比赛和间歇训练。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq1_a", locale)
	if (locale === "en") return en_timer_stopwatch_faq1_a(inputs)
	if (locale === "es") return es_timer_stopwatch_faq1_a(inputs)
	if (locale === "de") return de_timer_stopwatch_faq1_a(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq1_a(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq1_a(inputs)
	if (locale === "it") return it_timer_stopwatch_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq1_a(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq1_a(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq1_a(inputs)
	return zh_timer_stopwatch_faq1_a(inputs)
};